import './modules/global';
import QuantityControl from './modules/quantity-control';

window.addEventListener( 'load', () => {
	new QuantityControl();
} );
